module.exports = __webpack_public_path__ + "media/images/tmp/mag0-b059c63ab7254b603551b23a2f6b0a21.png";